import {
  NumberOperatorInput,
  Operator,
  OperatorInput,
  OperatorOutput,
  OperatorOutputMode,
  TreeItem,
  Xfo,
  XfoOperatorOutput,
} from '@zeainc/zea-engine'
import { UndoRedoManager, Change } from '@zeainc/zea-ux'
import AddKeyChange from './AddKeyChange.js'
import BaseTrack from './BaseTrack.js'
import KeyChange from './KeyChange.js'

/** An operator for aiming items at targets.
 * @extends Operator
 */
class TrackSampler extends Operator {
  track: BaseTrack
  __initialValue: any
  __currChange: any // TODO: Change needs member addSecondaryChange
  __secondaryChange: Change
  __secondaryChangeTime: number

  timeNumberOutput = new NumberOperatorInput('Time')
  xfoOutput = new XfoOperatorOutput('Output', OperatorOutputMode.OP_WRITE)
  /**
   * Create a TrackSampler operator.
   * @param {string} name - The name value.
   */
  constructor(name?: string, track?: BaseTrack) {
    super(name)

    this.track = track
    const setDirty = () => {
      this.setDirty()
    }
    this.track.on('keyAdded', setDirty)
    this.track.on('keyRemoved', setDirty)
    this.track.on('keyChanged', setDirty)

    this.addInput(this.timeNumberOutput)
    this.addOutput(this.xfoOutput)

    this.__initialValue = null
    this.__currChange = null
    this.__secondaryChange = null
    this.__secondaryChangeTime = -1

    this.getOutput('Output').on('paramSet', () => {
      this.__initialValue = this.getOutput('Output').getValue()
    })
  }

  /**
   * @param {Xfo} value - The value param.
   * @return {any} - The modified value.
   */
  backPropagateValue(value: Xfo) {
    const time = this.getInput('Time').getValue()
    // this.track.setValue(time, value)

    const undoRedoManager = UndoRedoManager.getInstance()
    const change = <any>undoRedoManager.getCurrentChange() // TODO: import change
    if (change && change.addSecondaryChange) {
      if (this.__currChange != change || this.__secondaryChangeTime != time) {
        this.__currChange = change
        this.__secondaryChangeTime = time

        const keyAndLerp = this.track.findKeyAndLerp(time)
        if (
          keyAndLerp.keyIndex == -1 ||
          keyAndLerp.lerp > 0.0 ||
          (keyAndLerp.keyIndex == this.track.getNumKeys() - 1 && this.track.getKeyTime(keyAndLerp.keyIndex) != time)
        ) {
          this.__secondaryChange = new AddKeyChange(this.track, time, value)
          this.__currChange.addSecondaryChange(this.__secondaryChange)
        } else {
          this.__secondaryChange = new KeyChange(this.track, keyAndLerp.keyIndex, value)
          this.__currChange.addSecondaryChange(this.__secondaryChange)
        }
      } else {
        this.__secondaryChange.update(value)
      }
    } else {
      const keyAndLerp = this.track.findKeyAndLerp(time)
      if (
        keyAndLerp.keyIndex == -1 ||
        keyAndLerp.lerp > 0.0 ||
        (keyAndLerp.keyIndex == this.track.getNumKeys() - 1 && this.track.getKeyTime(keyAndLerp.keyIndex) != time)
      ) {
        this.track.addKey(time, value)
      } else {
        this.track.setKeyValue(keyAndLerp.keyIndex, value)
      }
    }

    return value
  }

  /**
   * The evaluate method.
   */
  evaluate() {
    const output = this.getOutputByIndex(0)
    if (this.track.getNumKeys() == 0) {
      if (output.isConnected()) {
        // output.setClean(this.__initialValue)
        output.setClean(this.xfoOutput.getValue())
      }
    } else {
      const time = this.timeNumberOutput.getValue()

      const xfo = this.track.evaluate(time)
      output.setClean(xfo)
    }
  }
}

export { TrackSampler }
